// extracted by mini-css-extract-plugin
export default {"img":"About_img__co08k","MObimg":"About_MObimg__GKyL2","MobileHeading":"About_MobileHeading__1Ye8o","TabHeading":"About_TabHeading__ojFHs","Heading":"About_Heading__DPN7j"};